/* Desktop only: bounded columns and hover intent. The mobile menu is unchanged. */
(function () {
  'use strict';
  if (window.serlexDepartmentMenu) return;
  var desktop = window.matchMedia('(min-width: 992px) and (hover: hover)');
  var controllers = new Map();
  function mount(menu) {
    if (!desktop.matches || controllers.has(menu)) return;
    var list = menu.querySelector('.main-nav');
    var holder = menu.closest('.vertical-menu');
    var head = holder && holder.querySelector('.head');
    if (!list || !head) return;
    var active = null, closeTimer = 0, openTimer = 0, frame = 0, listeners = [];
    var rows = Array.from(list.children).filter(function (row) { return row.tagName === 'LI'; });
    var panels = new Map();
    rows.forEach(function (row) {
      var panel = Array.from(row.children).find(function (child) { return child.classList.contains('dropdown-menu'); });
      if (panel) panels.set(row, panel);
    });
    function on(target, event, handler) { target.addEventListener(event, handler); listeners.push(function () { target.removeEventListener(event, handler); }); }
    function cancelClose() { clearTimeout(closeTimer); }
    function close() {
      cancelClose(); clearTimeout(openTimer);
      if (active) active.classList.remove('serlex-department-open', 'mega-is-hover');
      active = null;
    }
    function open(row) {
      cancelClose(); clearTimeout(openTimer);
      if (active && active !== row) active.classList.remove('serlex-department-open', 'mega-is-hover');
      active = row; row.classList.add('serlex-department-open');
    }
    function leave() { clearTimeout(openTimer); cancelClose(); closeTimer = setTimeout(close, 550); }
    function layout() {
      var bounds = head.getBoundingClientRect();
      var columnWidth = Math.max(210, Math.round(bounds.width));
      var available = Math.max(columnWidth + 300, window.innerWidth - bounds.left - 18);
      var availableHeight = Math.max(240, window.innerHeight - bounds.bottom - 20);
      var requestedRows = parseInt(menu.dataset.departmentsPerColumn, 10) || 18;
      var wrap = menu.dataset.departmentColumns !== 'false';
      var perColumn = wrap ? Math.max(6, Math.min(requestedRows, Math.floor((availableHeight - 24) / 36))) : rows.length;
      var totalColumns = Math.max(1, Math.ceil(rows.length / perColumn));
      var visibleColumns = Math.min(totalColumns, Math.max(1, Math.min(3, Math.floor((available - 340) / columnWidth))));
      var menuWidth = visibleColumns * columnWidth;
      menu.dataset.serlexColumns = String(totalColumns);
      menu.dataset.serlexVisibleColumns = String(visibleColumns);
      menu.style.setProperty('--serlex-department-column-width', columnWidth + 'px');
      menu.style.setProperty('--serlex-department-rows', String(Math.min(perColumn, rows.length)));
      menu.style.setProperty('--serlex-department-width', menuWidth + 'px');
      menu.style.setProperty('--serlex-department-panel-width', Math.min(820, available - menuWidth) + 'px');
      menu.style.setProperty('--serlex-department-panel-height', Math.min(680, availableHeight) + 'px');
    }
    function queueLayout() { cancelAnimationFrame(frame); frame = requestAnimationFrame(layout); }
    menu.dataset.serlexHover = 'true';
    rows.forEach(function (row) {
      var panel = panels.get(row);
      on(row, 'mouseenter', function () {
        cancelClose(); clearTimeout(openTimer);
        if (!panel) { close(); return; }
        if (!active || active === row) open(row);
        else openTimer = setTimeout(function () { open(row); }, 120);
      });
      on(row, 'mouseleave', leave);
      if (panel) {
        on(panel, 'mouseenter', function () { open(row); });
        on(panel, 'mouseleave', leave);
      }
      on(row, 'focusin', function () { if (panel) open(row); else close(); });
      on(row, 'focusout', function (event) { if (!row.contains(event.relatedTarget)) leave(); });
    });
    on(menu, 'mouseleave', leave);
    on(document, 'click', function (event) { if (!menu.contains(event.target)) close(); });
    on(document, 'keydown', function (event) {
      if (event.key !== 'Escape' || !active) return;
      if (active.contains(document.activeElement)) document.activeElement.blur();
      close();
    });
    on(window, 'resize', queueLayout);
    on(head, 'click', queueLayout);
    var observer = new MutationObserver(function () { if (!menu.classList.contains('opened')) close(); queueLayout(); });
    observer.observe(menu, {attributes: true, attributeFilter: ['class']});
    layout();
    controllers.set(menu, function () {
      close(); cancelAnimationFrame(frame); observer.disconnect();
      listeners.forEach(function (off) { off(); });
      delete menu.dataset.serlexHover; delete menu.dataset.serlexColumns; delete menu.dataset.serlexVisibleColumns;
      ['column-width','rows','width','panel-width','panel-height'].forEach(function (key) { menu.style.removeProperty('--serlex-department-' + key); });
      controllers.delete(menu);
    });
  }
  function init(scope) {
    if (scope.matches && scope.matches('.vertical-navbar')) mount(scope);
    scope.querySelectorAll('.vertical-menu .vertical-navbar').forEach(mount);
  }
  function reset() { Array.from(controllers.values()).forEach(function (destroy) { destroy(); }); init(document); }
  window.serlexDepartmentMenu = {init: init};
  init(document);
  if (desktop.addEventListener) desktop.addEventListener('change', reset); else desktop.addListener(reset);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    Array.from(controllers.keys()).forEach(function (menu) { if (event.target.contains(menu)) controllers.get(menu)(); });
  });
})();
